var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports",
    transform: "translate(1194.5 -254.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1217.5 231.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Doc-Upload-White-Copy-49",
    transform: "translate(23 23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-165",
    d: "M9.75,0H13V13H9.75ZM4.875,4.875h3.25V13H4.875ZM0,8.125H3.25V13H0Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.528de5c86b0a6f4d94ba29e6f8da2e1a.svg";
export { ForwardRef as ReactComponent };